<template>
	
    <div class="vpay__split-buttons">
		<div v-for="(button, i) in buttons" class="vpay__split-button" :class="$css(styles['vpay__split-button'], (selected === button.key && styles['vpay__split-button--selected']))" :key="i" @click="onClickButton(button.key)">{{ button.label }}</div>
    </div>
	
</template>

<script>
	
    export default {
		
        name: "SplitButtons",
		
		props: {
			value: { type: String, default: "" },
			buttons: { type: Array, default() { return []; } }
		},
		
		computed: {
			
			styles() {
				return this.$style({
					"vpay__split-button": { "width": (100 / this.buttons.length) + '%' },
					"vpay__split-button--selected": {
						"font-weight": "500",
						"background-color": `rgba(0, 0, 0, 0.05)`,
						//"background-color": (this.$store.getters.brandColour ? `#${this.$store.getters.brandColour}` : `rgba(0, 0, 0, 0.05)`),
						"color": (this.$store.getters.brandColour ? this.$store.getters.brandColour : "inherit"),
					},
				});
			}
			
		},
		
		methods: {
			
			onClickButton(selected) {
				this.selected = selected;
				this.$emit("change", this.selected);
				this.$emit("input", this.selected);
			}
			
		},
		
		data() {
			
			return {
				selected: this.value,
			}
			
		}
		
    }
	
</script>

<style>
	
	
	
</style>
